<template>
  <section class="greeting">
    <img :src="require('@/assets/screens/greeting/okimi.png')" alt="Okimi" />
  </section>
</template>

<style lang="scss" scoped>
.greeting {
  background: #edeae7;
  display: grid;
  place-items: center;
  padding: 16px;

  img {
    max-width: 1000px;
    width: 100%;
  }
}
</style>
